import React from 'react';
interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
}
export function Card({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-slate-200 shadow-sm ${className}`} {...props} data-id="element-350">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`p-6 border-b border-slate-100 ${className}`} {...props} data-id="element-351">
      {children}
    </div>;
}
export function CardTitle({
  children,
  className = '',
  ...props
}: CardProps) {
  return <h3 className={`text-lg font-semibold text-slate-900 ${className}`} {...props} data-id="element-352">
      {children}
    </h3>;
}
export function CardContent({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`p-6 ${className}`} {...props} data-id="element-353">
      {children}
    </div>;
}